import { deepEqual } from 'assert';

export const isEqual = (a: any, b: any): boolean => {
  try {
    deepEqual(a, b);
    return true;
  } catch (error) {
    return false;
  }
};
